import { useEffect, useRef } from 'react';
import { useTemplatesListDispatch, useTemplatesListState } from '../context/UseTemplatesListContext';

export function useCloseSidebarOnNavigationChange(navigationKey: string) {
  const dispatch = useTemplatesListDispatch();
  const { selectedTemplate } = useTemplatesListState();
  const prevKeyRef = useRef(navigationKey);

  useEffect(() => {
    if (prevKeyRef.current !== navigationKey && selectedTemplate) {
      dispatch({ type: 'RESET_SELECTED_TEMPLATE' });
    }
    prevKeyRef.current = navigationKey;
  }, [navigationKey, selectedTemplate, dispatch]);
}
